import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {msg} from '@lit/localize';
import store from '../../../store';

import {
    selectDatasetnumber,
    selectDatasetnumber2, selectIsOnesided,
    selectLdt1,
    selectLdt2,
    selectPolar,
    selectPolar2,
    selectUlor,
    selectUlor2
} from '../../../selectors';

@customElement('polar-diagram')
export class PolarDiagram extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: block;
	  }

	  @media (min-width: 768px) {
		/*bp-small*/
		:host {
		  display: block;
		}
	  }

	  a {
		color: #000;
	  }

	  .image {
		margin-bottom: var(--specsheet-large-gap);
	  }

	  .col {
		margin-right: var(--specsheet-large-gap);
	  }

	  .text {
		font: var(--font-specsheet-light);
	  }

	  @media print {
		:host {
		  display:block;
		}

		.image {
		  margin-bottom: var(--specsheet-print-small-large-gap);
		}

		.col {
		  margin-right: var(--specsheet-print-large-gap);
		}

		.text {
		  font: var(--font-specsheet-print-light);
		}

	  }

	`
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = this.state.status.lang;
	}


	render() {
		const s = this.state;
		return html`

			<div class="col">

				<div class="image">
					<img src="${selectPolar(s)}" alt="polar">
				</div>

				<div class="text">
					<p>
						<trans-label key="LE_LightEngineModuleSize_1" context="FV.L"></trans-label>
						<br/>
						<trans-label key="LE_LightEngineDataset" context="D"></trans-label>
						: ${selectDatasetnumber(s)}<br/>
						<trans-label key="LU_ULOR" context="D.L"></trans-label>
						: ${selectUlor(s)} %<br/>
						<a href="${selectLdt1(this.state)}" target="_blank">${msg('LDT Side')} A</a>
					</p>
				</div>

			</div>

			${when(!selectIsOnesided(s), () => html`
				<div class="col">

					<div class="image">
						<img src="${selectPolar2(s)}" alt="polar">
					</div>

					<div class="text">
						<p>
							<trans-label key="LE_LightEngineModuleSize_2" context="FV.L"></trans-label>
							<br>
							<trans-label key="LE_LightEngineDataset" context="D"></trans-label>
							: ${selectDatasetnumber2(s)}<br>
							<trans-label key="LU_ULOR" context="D.L"></trans-label>
							: ${selectUlor2(s)} %<br/>
							<a href="${selectLdt2(this.state)}" target="_blank">${msg('LDT Side')} B</a>
						</p>
					</div>

				</div>
			`)}

		`;
	}
}
